import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class AdminSuperService {
	constructor(private http: HttpClient) {}

	public sendverificationemailchasers(emailType: Number) {
		return this.http.get(`api/adminsuper/sendverificationemailchasers/${emailType}`);
	}

	public updatehubspotandhyperline() {
		return this.http.get(`api/adminsuper/updatehubspotandhyperline`);
	}

	public addFinanceApproverRole(searchString: string) {
		return this.http.post(`api/accounts/addFinanceApproverRole`, searchString);
	}
}
